var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPullCordSwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.43,13.37c-1.55,0-2.81-1.3-2.81-2.91s1.26-2.91,2.81-2.91s2.81,1.3,2.81,2.91S5.98,13.37,4.43,13.37z  M4.43,8.06c-1.27,0-2.31,1.08-2.31,2.41s1.04,2.41,2.31,2.41s2.31-1.08,2.31-2.41S5.7,8.06,4.43,8.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.2,8.55 5.83,8.21 11.06,2.53 14.3,5.45 13.97,5.82 11.1,3.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.83,7.04 10.83,2.88 11.33,2.88 11.33,5.45 11.45,5.28 11.86,5.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.41,
    y: 5.31,
    transform: "matrix(0.8567 -0.5158 0.5158 0.8567 -1.5749 6.3617)",
    className: "st2",
    width: 0.5,
    height: 1.41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPullCordSwitch);
export default __webpack_public_path__ + "static/media/PullCordSwitch.e1a71fb30ccfd675f6dfdf3aeb8556c2.svg";
export { ForwardRef as ReactComponent };